export const DEVELOPER_ROLE_ID = 2;

export const callers = [
    'brodie@fergusapp.com',
    'ross@fergusapp.com',
    'andrew@fergusapp.com',
    'jesse@fergusapp.com',
    'dan@fergusapp.com',
    'micah@fergusapp.com',
    'jono@fergusapp.com',
    'milly@fergusapp.com',
    'athalia@fergusapp.com',
    'charlie@fergusapp.com',
    'cameron@fergusapp.com',
    'abraham@fergusapp.com',
    'lauren@fergusapp.com',
    'samuel@fergusapp.com',
    'marvin@fergusapp.com',
    'dom.gattellari@fergusapp.com',
    'josh.turpie@fergusapp.com',
    'luke.hegarty@fergusapp.com',
    'nick.desilva@fergusapp.com',
    'paul.macindoe@fergusapp.com',
    'kristie@fergusapp.com',
    'mike@fergusapp.com',
    'omar.ebrahimi@fergusapp.com',
    'anna.harper@fergus.com',
    'justin.billie@fergus.com'
];

export const australians = [
    'jesse@fergusapp.com',
    'josh.turpie@fergusapp.com',
    'luke.hegarty@fergusapp.com',
    'nick.desilva@fergusapp.com',
    'paul.macindoe@fergusapp.com',
    'omar.ebrahimi@fergusapp.com',
    'anna.harper@fergus.com'
];

const initialState = {
    loaded: false,
    users: [],
    usersWithTrashed: []
};

var transformUsers = (users) =>
    users
        .filter(user => !user.deletedAt)
        .map(user => ({...user, isFg: user.organisationName == 'Fergus'}));

export default function users(state = initialState, action = {}) {    
    switch (action.type) {
        case 'USER_LOAD':
            return {
                ...state,
                loading: true
            };
        case 'USER_LOAD_SUCCESS':
            return {
                ...state,
                loading: false,
                loaded: true,
                users: transformUsers(action.result),
                usersWithTrashed: action.result,
                error: null
            };
        case 'USER_LOAD_FAIL':
            return {
                ...state,
                loading: false,
                loaded: false,
                users: null,
                error: action.error
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/users.js